import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-integer";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function isPercentParam(param) {
  return ['covering', 'deadtime'].includes(param);
} // mutation


export var setDailyStats = function setDailyStats(state, value) {// state.dailyStats = value
}; // action

export var updateDailyStats = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var getters, rootGetters, rootState, commit;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getters = _ref.getters, rootGetters = _ref.rootGetters, rootState = _ref.rootState, commit = _ref.commit;

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateDailyStats(_x) {
    return _ref2.apply(this, arguments);
  };
}(); // getters

export var getDailyStats = function getDailyStats(state) {
  function prettyNumbers(obj, paramName) {
    return Object.keys(obj).reduce(function (accumulator, key) {
      var number = obj[key];
      var normalizedNumber = Number.isInteger(number) ? number : number.toFixed(2);

      if (isPercentParam(paramName)) {
        // percents
        normalizedNumber = Math.round(normalizedNumber * 100);
      }

      accumulator[key] = normalizedNumber;
      return accumulator;
    }, {});
  }

  var stats = state.efficiency['day_stats'];
  var dailyStats = stats && Object.keys(stats).reduce(function (accumulator, key) {
    accumulator[key] = prettyNumbers(stats[key], key);
    return accumulator;
  }, {});
  var param1 = state.dailyStatsParam1;
  var param2 = state.dailyStatsParam2;
  var stats1 = dailyStats === null || dailyStats === void 0 ? void 0 : dailyStats[param1];
  var stats2 = dailyStats === null || dailyStats === void 0 ? void 0 : dailyStats[param2];
  return [stats1, stats2];
};
export var getDailyStatsSummary = function getDailyStatsSummary(state, getters) {
  function prettySum(obj, paramName) {
    var keys = Object.keys(obj);
    var sum = keys.reduce(function (accumulator, key) {
      accumulator += Number(obj[key]);
      return accumulator;
    }, 0);

    if (isPercentParam(paramName)) {
      return Math.round(sum / keys.length);
    } else {
      return sum;
    }
  }

  var _getters$getDailyStat = _slicedToArray(getters.getDailyStats, 2),
      stats1 = _getters$getDailyStat[0],
      stats2 = _getters$getDailyStat[1];

  if (stats1 && stats2) {
    var param1 = state.dailyStatsParam1;
    var param2 = state.dailyStatsParam2;
    return [prettySum(stats1, param1), prettySum(stats2, param2)];
  } else {
    return [0, 0];
  }
};
export var isPercent = function isPercent(state) {
  return [isPercentParam(state.dailyStatsParam1), isPercentParam(state.dailyStatsParam2)];
};